module.exports = "<div>\n\t<div class=\"row\">\n\t\t<div class=\"l12 m12\">\n\t\t\tVersione attuale Nemo-gui : {{version}}\n\t\t</div>\n\t</div>\n\n</div>\n"